import React from 'react'

/**
 * F-108: below 600 px the chat panels take the whole screen; from 600 px up (a
 * tablet, an unfolded Galaxy Fold, a desktop) they are a sidebar on the right
 * over a backdrop. The decision is the width alone, never touch or user agent.
 */
export const SIDE_PANEL_CLASSES =
  'min-[600px]:left-auto min-[600px]:right-0 min-[600px]:w-[380px] min-[600px]:border-l min-[600px]:border-gray-200 min-[600px]:shadow-[-8px_0_32px_rgba(15,23,42,0.14)]'

/** The backdrop behind the sidebar (600 px and up); a tap closes the panel. */
export const SIDE_BACKDROP_CLASSES = 'fixed inset-0 z-50 hidden bg-black/30 min-[600px]:block'

/** A swipe to the right on the panel closes it (touch screens, any width). */
export const useSwipeToClose = (onClose: () => void) => {
  const start = React.useRef<{ x: number; y: number } | null>(null)
  return {
    onTouchStart: (e: React.TouchEvent) => {
      const touch = e.touches[0]
      start.current = touch ? { x: touch.clientX, y: touch.clientY } : null
    },
    onTouchEnd: (e: React.TouchEvent) => {
      const from = start.current
      const touch = e.changedTouches[0]
      start.current = null
      if (!from || !touch) return
      const dx = touch.clientX - from.x
      const dy = Math.abs(touch.clientY - from.y)
      if (dx > 80 && dx > dy * 2) onClose()
    }
  }
}
